import moment from "moment"
// 图：页面默认图表展示14天、6周、6月；
// 宽表：默认8天6周6月
// ua页面pubg 相关，朝前推一天

export const getDefaultDateValue = (type: string,isTable?: boolean,isUAPUBGM?:boolean, ) => {
  const endVal = isUAPUBGM ? 2 : 1;
  const startVal = isTable ? (isUAPUBGM ? 9 : 8) : (isUAPUBGM ? 15 : 14)
  const currDate = moment();
  const currWeek = currDate.week();
  const currMonth = currDate.month();

  if (type?.toLocaleLowerCase() === 'week') {
    return [
      moment().week(currWeek - 6).startOf('isoWeek').format('YYYY-MM-DD'),
      moment().week(currWeek - 1).endOf('isoWeek').format('YYYY-MM-DD')
    ]
  } else if (type?.toLocaleLowerCase() === 'month') {
    return [moment().month(currMonth - 6).startOf('month').format('YYYY-MM-DD'),
    moment().month(currMonth- 1).endOf('month').format('YYYY-MM-DD')
    ]
  } else {
    return  [moment().subtract(startVal, 'day').format('YYYY-MM-DD'), 
    moment().subtract(endVal, 'day').format('YYYY-MM-DD')
  ]
  }
}